import styled from 'styled-components';

export const AlertContainer = styled.div`
  > .MuiAlert-standardSuccess {
    background-color: rgba(10, 141, 84, 0.22);
  }
`;
